module.exports = __webpack_public_path__ + "images/otc-96b016.png";